import Repository from "./RepositoryFactoryMain";
const ADD_ORDER = "add";
const UPDATE_ORDER = "updateOrder";
const GET_ORDER = "getOrder";
const GET_ORDER_BY_USERID = "getOrderByUserId";
const GET_DETAILED_CATEGORY = "getDetailedCategory";
const PRODUCT_IMAGE = "addProductImage";

export default {
  addOrder(payload) {
    return Repository.post(transformRoute(ADD_ORDER), payload);
  },
  updateOrder(payload) {
    return Repository.post(transformRoute(UPDATE_ORDER), payload);
  },
  getOrder(payload) {
    return Repository.post(transformRoute(GET_ORDER), payload);
  },
  getOrderByUserId() {
    return Repository.post(transformRoute(GET_ORDER_BY_USERID));
  },
  getDetailedCategory() {
    return Repository.post(transformRoute(GET_DETAILED_CATEGORY));
  },
  productImage(payload) {
    return Repository.post(transformRoute(PRODUCT_IMAGE), payload);
  },
};

const transformRoute = (route) => {
  return `/ecom/orders/${route}`;
};
